import { reactive } from 'vue';

// Типы ролей в системе (перечисления)
export const ROLE_TYPES = {
  USER: 'user',
  ADMIN: 'admin',
  ATAMEKEN_ADMIN: 'atameken_admin',
};

// Определение привилегий
export const PERMISSIONS = {
  // Привилегии для управления ОТП
  DOMESTIC_PRODUCER_VIEW: 'domestic_producer_view',
  DOMESTIC_PRODUCER_CREATE: 'domestic_producer_create', 
  DOMESTIC_PRODUCER_EDIT: 'domestic_producer_edit',
  DOMESTIC_PRODUCER_DELETE: 'domestic_producer_delete',
  DOMESTIC_PRODUCER_IMPORT: 'domestic_producer_import',
  
  // Привилегии для управления пользователями
  USER_MANAGEMENT: 'user_management',
  
  // Привилегии для других модулей
  SMART_SEARCH: 'smart_search',
  BENCHMARK_MANAGEMENT: 'benchmark_management',
};

// Распределение привилегий по ролям
export const ROLE_PERMISSIONS = {
  [ROLE_TYPES.USER]: [
    PERMISSIONS.DOMESTIC_PRODUCER_VIEW,
    PERMISSIONS.SMART_SEARCH,
  ],
  
  [ROLE_TYPES.ATAMEKEN_ADMIN]: [
    PERMISSIONS.DOMESTIC_PRODUCER_VIEW,
    PERMISSIONS.DOMESTIC_PRODUCER_CREATE,
    PERMISSIONS.DOMESTIC_PRODUCER_EDIT,
    PERMISSIONS.DOMESTIC_PRODUCER_DELETE,
    PERMISSIONS.DOMESTIC_PRODUCER_IMPORT,
    PERMISSIONS.SMART_SEARCH,
  ],
  
  [ROLE_TYPES.ADMIN]: [
    // Администратор имеет все привилегии
    ...Object.values(PERMISSIONS),
  ],
};

// Метки ролей для отображения в интерфейсе
export const ROLE_LABELS = {
  [ROLE_TYPES.USER]: 'Пользователь',
  [ROLE_TYPES.ADMIN]: 'Администратор',
  [ROLE_TYPES.ATAMEKEN_ADMIN]: 'Администратор Атамекен',
};

// Реактивное хранилище для управления ролями
export const roleState = reactive({
  // Текущая роль пользователя
  role: localStorage.getItem('user_role') || ROLE_TYPES.USER,
  
  // Метод для проверки наличия роли
  hasRole(role) {
    return this.role === role;
  },
  
  // Метод для проверки наличия привилегии
  hasPermission(permission) {
    const userPermissions = ROLE_PERMISSIONS[this.role] || [];
    return userPermissions.includes(permission);
  },
  
  // Метод для проверки наличия любой из указанных привилегий
  hasAnyPermission(permissions) {
    if (!Array.isArray(permissions)) {
      permissions = [permissions];
    }
    
    return permissions.some(permission => this.hasPermission(permission));
  },
  
  // Метод для проверки наличия всех указанных привилегий
  hasAllPermissions(permissions) {
    if (!Array.isArray(permissions)) {
      permissions = [permissions];
    }
    
    return permissions.every(permission => this.hasPermission(permission));
  },
  
  // Получение метки роли для отображения
  getRoleLabel(role = null) {
    const roleToCheck = role || this.role;
    return ROLE_LABELS[roleToCheck] || 'Неизвестно';
  },
  
  // Установка роли
  setRole(role) {
    if (ROLE_TYPES[role] || Object.values(ROLE_TYPES).includes(role)) {
      this.role = role;
      localStorage.setItem('user_role', role);
    }
  }
}); 